/**
 * Login constants
 */

export const LOGIN_REQUEST = 'platform/Login/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'platform/Login/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'platform/Login/LOGIN_ERROR';
